
import "~/assets/css/index.css";
import Draw from "~/components/draw.vue";
import Operate from "~/components/operate.vue";
import { language } from "~/utils/language.js";
import { svgCode } from "~/utils/svg-code.js";
import { mapGetters } from "vuex";
import { getUserInfoAPI } from "~/api";
import { getUserKeyAPI } from "~/api";
import { ResponseCode } from "~/constants";
import { sendAli } from "~/utils/send-ali.js";
import { demoData } from "~/utils/ai-demo.js";
import { eventBus } from "~/utils/eventBus.js";

export default {
  name: "HomePage",
  components: {
    Draw,
    Operate
  },
  computed: {
    ...mapGetters(["getUserInfo", "lan"])
  },
  head() {
    return {
      title: this.$t('indexPage.pageTitle'),
      meta: [
        { hid: "description", name: "description", content: this.$t('indexPage.pageDescription') },
      ],
      link: [
        { rel: 'stylesheet', href: "https://remaker.ai/userspace/saasbox/seo-html-tool/seo-html-tool-new.css" },
        { rel: 'stylesheet', href: "https://remaker.ai/userspace/saasbox/seo-html-tool/tools.css" },
        {
          rel: "canonical",
          href: `https://remaker.ai${this.localePath({
            path: "/ai-tattoo-generator/",
          })}`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: "https://remaker.ai/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "ja",
          href: "https://remaker.ai/jp/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://remaker.ai/kr/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "de",
          href: "https://remaker.ai/de/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "fr",
          href: "https://remaker.ai/fr/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "pt",
          href: "https://remaker.ai/pt/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "es",
          href: "https://remaker.ai/es/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "zh",
          href: "https://remaker.ai/zh/ai-tattoo-generator/",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://remaker.ai/ai-tattoo-generator/",
        },
      ]
    }
  },
  data() {
    return {
      config: demoData,
      configData: null,
      radioLan: "1",
      language: language,
      optionsLan: [
        {
          value: "1",
          label: "English",
        },
        {
          value: "2",
          label: "中文",
        },
        {
          value: "3",
          label: "Indonesian",
        },
      ],
      uid: "",
      svgCode: svgCode,
      exName: "",
      exLogo: "",
      aLiId: "web-ai-tattoo",
      logstore: "web-remaker",
      showModal: false,
      enlarge_image: "",
      historyArr: [],
      target_content: "",
      swap_content: "",
      guidance_scale: 1,
      prompt:
        "chinese pavilion on water background, luminous 3d style, anime aes-thetic, circular shapes,xing xing, romantic scenes, organic material,multidimensional shading",
      error_message: "",
      code: 200,
      load: false,
      imgSrc: [],
      template: null,
      itemT: "",
      historyArrDis: [],
      textImg: null,
      dialogVisible: false,
      exUrl: "./img/face/default.webp",
      browser: "",
      artStyle: 0,
      loginCreditNum: 0,
      firstCode: "",
      creditType: [],
      openPreNum: 0,
      numUser: 0,
      loadingUser: false,
      openLoginDialog: false,
      isMobile: false,
      isRemaker: "",
      generateType: 1, // 1: v1模型， 2: v2模型
      webData: {
        remaker: {
          logo: "/img/logo-word-remaker.webp",
          faceUrl: "https://remaker.ai/multiple-face-swap",
          faceVideoUrl: "https://remaker.ai/face-swap-video",
          url: "https://remaker.ai",
          serviceUrl: {
            zh: "https://remaker.ai/cn/service_agreement_remaker",
            en: "https://remaker.ai/en/terms-and-conditions",
            id: "https://remaker.ai/en/terms-and-conditions",
          },
          privacyUrl: {
            zh: "https://remaker.ai/cn/privacy-and-cookies-policy",
            en: "https://remaker.ai/en/privacy-and-cookies-policy",
            id: "https://remaker.ai/en/privacy-and-cookies-policy",
          },
        },
        vmodel: {
          logo: "/img/logo-word.webp",
          faceUrl: "https://vmodel.ai/features/multiple-face-swap/",
          url: "https://vmodel.ai",
          serviceUrl: {
            zh: "https://vmodel.ai/cn/service_agreement_vmodel",
            en: "https://vmodel.ai/en/service_agreement_vmodel",
            id: "https://vmodel.ai/en/service_agreement_vmodel",
          },
          privacyUrl: {
            zh: "https://vmodel.ai/cn/privacy-and-cookies-policy",
            en: "https://vmodel.ai/en/privacy-and-cookies-policy",
            id: "https://vmodel.ai/en/privacy-and-cookies-policy",
          },
        },
      },
      isDisable: true,
      tools1: [],
      tools2: [],
      toolsLoad: true,
      changeInputData: null,
      isSelectVisible: false,
      mesFb: "",
      openGift: false,
      faceLoginGift: 0,
      isSpring: true,
      percentage: 0,
      lastUploadTime: "",
      lastUpload: "",
      requestIdMap: {}, // 缓存正在轮询的requestId, 防止重复创建计时器
      drawLoading: false, // 控制结果展示区域是否loading
      generateParam: {},
      viewApi: 0,
    };
  },
  methods: {
    scrollToTop() {
      let topDom = this.isMobile ? window : document.querySelector('.content-area');
      topDom.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToAnchor(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
    openPriceDialog() {
      this.$refs.pricePai.openPriceDialog();
      this.viewApi++;
    },
    copy() {
      this.$message({
        message: this.language.copySuccess[this.lan],
        type: "success",
        showClose: true,
      });
    },
    priceEmit() {
      eventBus.$emit("priceEmitBus");
    },
    loginEmit() {
      eventBus.$emit("loginEmitBus");
    },
    async getUserEmit() {
      // this.loadingUser = true;
      const resp = await getUserInfoAPI();
      this.loadingUser = false;

      if (resp && resp.code === ResponseCode.SUCCESS) {
        let res = JSON.parse(localStorage.getItem("userInfo"));
        let obj = res;
        obj.five_star = resp.data.five_star;
        obj.email = resp.data.email;
        obj.payment = resp.data.payment;
        // obj.credits = resp.data.credits - resp.data.freeze_credits;
        obj.day_sign_new = resp.data.day_sign_new;
        // obj.day_sign_credits = resp.data.day_sign_credits;

        // 积分
        let current_credit = resp.data.credits;
        let freeze_credit = resp.data.freeze_credits;
        let sign_credit = resp.data.day_sign_credits;


        // 前端展示签到积分
        let display_sign_credit = 0;
        display_sign_credit = sign_credit - freeze_credit;
        // 有可能免费积分不够扣除
        if (display_sign_credit < 0) {
          display_sign_credit = 0;
        }

        // 前端展示当前积分
        let display_current_credit = current_credit;
        // 免费积分不够，使用当前积分来扣除
        if (sign_credit - freeze_credit < 0) {
          display_current_credit =
            current_credit - (freeze_credit - sign_credit);
        }
        // 有可能跨天的时候，免费积分没了，但是用户冻结积分还没有真正扣除，这个时候归零就行。后端也是同样的逻辑
        if (display_current_credit < 0) {
          display_current_credit = 0;
        }

        let isDay = true; //是否能使用每日积分

        if (isDay) {
          obj.credits = display_current_credit;
        } else {
          obj.credits = current_credit - freeze_credit;
        }

        obj.day_sign_credits = display_sign_credit;

        obj.ifBuyFirst = resp.data.discount_plans[this.firstCode];
        localStorage.setItem("userInfo", JSON.stringify(obj));
        this.$store.commit("setUserInfo", obj);

        // 获取user-key
        const data = {
          loginType: obj.loginType,
          userId: resp.data.user_id,
          email: resp.data.email,
        };
        const result = await getUserKeyAPI(data);
        if (result.code === ResponseCode.SUCCESS) {
          // 调用 KodePay 的注册逻辑
          window.KodePay.register_login_information(result.data.user_key);
        }
      }
      //隐藏index中的loading
      if (document.getElementById("loadingMask")) {
        document.getElementById("loadingMask").remove();
      }

      return resp; // 返回响应，以便使用 Promise 链
    },
    pullResultEmit(event) {
      this.pullResult(event, true);
    },
    pullResult(event, notLoad = false) {
      let that = this;
      this.percentage = 0;
      let nowTime = event.time;
      let requestId = event.requestId ? event.requestId.substring(
        0,
        event.requestId.lastIndexOf("_")
      ) : event.jobId.substring(
        0,
        event.jobId.lastIndexOf("_")
      );
      if (requestId in this.requestIdMap) {
        return;
      }
      if (event.upload instanceof Array) {
        this.lastUpload = event.upload[0];
      } else {
        this.lastUpload = event.upload;
      }
      let date = new Date(nowTime);
      // 获取年、月、日、时、分、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始计数的，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      // 格式化为字符串
      this.lastUploadTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      if (!notLoad) {
        //变成加载中状态
        this.load = true;
      }
      // 轮询获取生成结果
      let t = setInterval(async () => {
        if (this.percentage < 70) {
          this.percentage += 20;
        }
        await fetch(
          `https://api.remaker.ai/api/pai/v3/ai-tattoo/get-job/${requestId}`,
          {
            headers: {
              source: "ai_portrait",
              Authorization: this.getUserInfo.token
                ? this.getUserInfo.token
                : "",
              "Product-Code": "067003",
            },
            method: "get",
          }
        )
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            if (
              res.code == 100000 &&
              res.result.output_image_url &&
              res.result.output_image_url.length > 0
            ) {
              if (!notLoad) {
                this.code = 200;
                this.load = false;
                this.imgSrc = res.result.output_image_url;
                // 通知布局组件生成操作结束
                this.$root.$emit('generate-end');
              }

              clearInterval(t);
              sendAli(
                this.aLiId, "generate_image_success",
                {
                  image_url: JSON.stringify(res.result.output_image_url),
                  job_id: res.result.job_id
                });

              for (let i in res.result.output_image_url) {
                let img = res.result.output_image_url[i];
                //更新历史记录为成功
                this.$refs.historyRef.updateSuccess(requestId + "_" + i, img);
              }
            } else if (res.code != 100000 && res.code != 300006) {
              // 获取积分
              this.getUserEmit();
              if (!notLoad) {
                this.load = false;
                this.code = 500;
                this.error_message =
                  this.language.portraitGenerateFail[this.lan];
                this.imgSrc = [];
                // 通知布局组件生成操作结束
                this.$root.$emit('generate-end');
              }
              clearInterval(t);
              sendAli(this.aLiId, "generate_image_false");
              for (let i = 0; i < (this.generateType === 1 ? 2 : 1); i++) {
                //更新历史记录为失败
                this.$refs.historyRef.updateFail(requestId + "_" + i);
              }
            } else {
              if (nowTime && new Date().getTime() - nowTime > 300000) {
                // 获取积分
                this.getUserEmit();
                clearInterval(t);
                if (!notLoad) {
                  this.load = false;
                  this.code = 500;
                  this.imgSrc = [];
                  this.error_message = this.language.errorTip[this.lan];
                  // 通知布局组件生成操作结束
                  this.$root.$emit('generate-end');
                }
                sendAli(this.aLiId, "generate_image_false");
                for (let i = 0; i < (this.generateType === 1 ? 2 : 1); i++) {
                  //更新历史记录为失败
                  this.$refs.historyRef.updateFail(requestId + "_" + i);
                }
              }
            }
          })
          .catch((e) => {
            clearInterval(t);
            if (!notLoad) {
              this.load = false;
              this.code = 500;
              this.error_message = this.language.errorTipLan[this.lan];
              // 通知布局组件生成操作结束
              this.$root.$emit('generate-end');
            }
          });
      }, 5000);
      this.requestIdMap[requestId] = t;
    },
    generateEmit(param, localConfig, type) {
      this.generateType = type;
      if (this.isMobile) {
        let targetSection = document.getElementById("draw");
        targetSection.scrollIntoView({ behavior: "smooth" });
      }

      // 通知布局组件生成操作开始
      this.$root.$emit('generate-start');

      let that = this;

      const formData = new FormData();
      for (let key in param) {
        formData.append(key, param[key]);
      }
      // 添加style参数
      if (localConfig && localConfig.style) {
        formData.append('style_key', localConfig.style);
      }
      // 添加宽高参数
      if (type === 1 && param.width && param.height) {
        formData.append('width', param.width);
        formData.append('height', param.height);
      } else {
        formData.append('aspect_ratio', param.aspect_ratio);
      }
      // 身体部位
      if (param.bodyPart)
        formData.append('body_part', param.bodyPart);
      // 负面提示词
      if (localConfig && localConfig.negativePrompt)
        formData.append('negative_prompt', localConfig.negativePrompt);
      // 提示词强度
      if (localConfig && localConfig.complexity)
        formData.append('strength', localConfig.complexity);

      this.generateParam = param;

      // 设置drawLoading为true，显示加载指示器
      this.drawLoading = true;

      fetch(type === 1
          ? "https://api.remaker.ai/api/pai/v3/ai-tattoo/create-job"
          : "https://api.remaker.ai/api/pai/v3/ai-tattoo/create-job-v2", {
        headers: {
          Authorization: this.getUserInfo.token ? this.getUserInfo.token : "",
          "Product-Code": "067003",
        },
        method: "post",
        body: formData,
      })
        .then((res) => {
          return res.json();
        })
        .then((resOne) => {
          try {
            if (resOne.code == 100000) {
              this.code = 200;
              this.load = true;
              this.imgSrc = [];
              // 获取积分
              this.getUserEmit().then(() => {
                // 通知内容已加载
                this.$root.$emit('content-loaded');
              });
              that.generateParam.input = resOne.result.input_image_url;
              // 这里 v1 模型生成 2 张图，v2 生成 1 张图，所以历史记录按照模型不同添加的图片数也不同
              for (let i = 0; i < (this.generateType === 1 ? 2 : 1); i++) {
                that.imgSrc.push("");
                //添加历史记录
                that.$refs.historyRef.addHistory(
                  resOne.result.request_id + "_" + i,
                  resOne.result.request_id,
                  null,
                  { upload: resOne.result.input_image_url }
                );
              }
              that.pullResult({
                url: "",
                done: 1,
                requestId: resOne.result.request_id + "_",
                time: new Date().getTime(),
                upload: resOne.result.input_image_url,
              });
            }
            else if (resOne.code == 400101 || resOne.code == 300002) {
              this.load = false;
              this.code = 200;
              // 通知布局组件生成操作结束
              this.$root.$emit('generate-end');
              //需要弹出登录弹窗
              this.$message({
                message: resOne.message[this.lan]
                  ? resOne.message[this.lan]
                  : resOne.message.en,
                type: "warning",
                duration: 3000,
                customClass: "message-box",
              });
              if (resOne.code == 400101) {
                this.loginEmit();
              } else {
                this.priceEmit();
              }
              sendAli(this.aLiId, "reach_limit");
              // 请求失败，取消加载指示器
              this.drawLoading = false;
            }
            else {
              this.load = false;
              this.code = 500;
              // 通知布局组件生成操作结束
              this.$root.$emit('generate-end');
              this.error_message = resOne.message[this.lan]
                ? resOne.message[this.lan]
                : resOne.message.en;
              if (resOne.code == 200008) {
                location.reload();
              }
              // 请求失败，取消加载指示器
              this.drawLoading = false;
            }
          } catch (err) {
            console.log(err);
            this.error_message = this.language.qrError[this.lan];
            // 通知布局组件生成操作结束
            this.$root.$emit('generate-end');
            // 发生错误，取消加载指示器
            this.drawLoading = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.error_message = this.language.errorTipLan[this.lan];
          // 通知布局组件生成操作结束
          this.$root.$emit('generate-end');
          // 请求出错，取消加载指示器
          this.drawLoading = false;
        })
        .finally(() => {
          this.drawLoading = false;
        });
    },
    showEmit(item) {
      this.showModal = true;
      this.enlarge_image = item;
    },
    discordJump() {
      window.open("https://discord.gg/CKNFPfFk2K");
    },
    jump(url) {
      window.open(url);
    },
    closeRemark() {
      this.remarkShow = false;
    },
    down(image_url) {
      // 发送下载埋点，包含图片URL和模型类型
      sendAli(this.aLiId, "down_image", JSON.stringify({
        image_url: image_url,
        model_type: this.generateType === 1 ? "v1" : "v2"
      }));
      const fileName = image_url.split('/').pop();
      let xhr = new XMLHttpRequest();
      xhr.open("get", image_url);
      xhr.responseType = "blob";
      xhr.onload = () => {
        let mu = URL.createObjectURL(xhr.response);
        let doc = document;
        let a = doc.createElement("a");
        a.href = mu;
        a.download = fileName;
        a.textContent = "download";
        doc.body.append(a);
        a.click();
        this.downloading = false;
        setTimeout(() => {
          a.remove();
          URL.revokeObjectURL(mu);
        }, 0);
      };
      xhr.send();
    },
  },
  mounted() {
    if (location.host.includes("remaker")) {
      this.isRemaker = "remaker";
    } else {
      this.isRemaker = "vmodel";
    }

    this.loadingUser = true;
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("mobile")) {
      this.isMobile = true;
    } else {
      if (window.innerWidth < 1050) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      window.addEventListener("resize", () => {
        if (window.innerWidth < 1050) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    }

    let topDom = this.isMobile ? window : document.querySelector('.content-area');

    // 添加滚动监听器，控制回到顶部按钮的显示和隐藏
    topDom.addEventListener('scroll', () => {
      const backToTopButton = document.getElementById('remaker-back-to-top');
      let topDomScroll;
      if (this.isMobile) {
        topDomScroll = window.scrollY;
      } else {
        topDomScroll = document.querySelector('.content-area').scrollTop;
      }
      if (backToTopButton) {
        if (topDomScroll > 1200) {
          backToTopButton.style.display = 'block';
        } else {
          backToTopButton.style.display = 'none';
        }
      }
    });

    if (navigator.userAgent.includes("FBAV")) {
      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        this.mesFb = 1;
      } else if (navigator.userAgent.match(/Android/i)) {
        this.mesFb = 2;
      } else {
        // alert("页面在Facebook内嵌浏览器中打开, 用户在其他设备上打开网页")
      }
    } else {
      // alert("页面在普通浏览器中打开");
    }

    fetch(
      "https://remaker.ai/userspace/settings/spring_ext_ai_face.setting.kodepaydev.v1.json?v=3"
    )
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        try {
          this.loginCreditNum = res.login.aiPortrait;
          this.creditType = res.pay;
          this.faceLoginGift = res.login.faceLoginGift;
          this.creditType.map((i) => {
            if (i.codeFirst) {
              this.firstCode = i.codeFirst;
            }
          });
          this.getUserEmit().then(() => {
            this.$root.$emit('content-loaded');
          });
        } catch (err) {
          console.log(err);
        }
      });
    // FAQ面板的点击事件处理
    const faqPanel = document.querySelector('.remaker-container-faq-panel');
    if (faqPanel) {
      faqPanel.style.display = "block";
    }
    var acc = document.getElementsByClassName("remaker-container-faq-accordion");
    for (var i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  },
  watch: {
    radioLan() {
      // this.lan =
      //   this.radioLan == "1" ? "en" : this.radioLan == "2" ? "zh" : "id";
    },
    historyArr() {
      this.historyArrDis = [...this.historyArr].reverse();
    },
    target_content() {
      if (!this.target_content || !this.swap_content) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    swap_content() {
      if (!this.target_content || !this.swap_content) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
  },
  async created() {
    // await this.loadConfig();
  },
};
